module.exports = __webpack_public_path__ + "static/category_cpd.121ed623.png";